
import { Component, Vue } from 'vue-property-decorator'
import CustomerInfo from '@/components/desktop-pos/customer-info.vue'
import PriceSummary from '@/components/desktop-pos/price-summary.vue'
import MemberCard from '@/components/desktop-pos/member-card.vue'
import Receipt from '@/components/Receipt.vue'
import { mapState, mapActions } from 'vuex'
import Printer from '@/libs/imin-printer.esm.browser.min'
import html2canvas from 'html2canvas'
import OrderProvider from '@/resources/order.provider'
import DesktopPosNavbar from '@/components/desktop-pos/navbar.vue'

const orderProvider = new OrderProvider()

@Component({
    components: {
        CustomerInfo,
        PriceSummary,
        MemberCard,
        Receipt,
        DesktopPosNavbar
    },
    computed: {
        ...mapState({
            selectBranch: (state: any) => state.Store.selectBranch,
            selectPos: (state: any) => state.Store.selectPos
        })
    },
    methods: {
        ...mapActions({
            clearCart: 'Cart/clearCart',
            exchangeClearCart: 'ExchangeOrder/clearCart'
        })
    }
})
export default class OrderSuccess extends Vue {
    base64Url = ''

    bill: any = null

    status = ''

    get isExchangeOrder (): boolean {
      return this.$route.query?.type === 'exchange-order'
    }

    get changeAmount (): number | null {
      return this.bill?.payments?.length ? this.bill?.payments[this.bill?.payments.length - 1]?.changeAmount : null
    }

    selectBranch!: any

    selectPos!: any

    loading = false

    printLoading = false

    billId = ''

    printer!: any

    exchangeClearCart!: any

    clearCart!: any

    showPriceFormat!: any

  async mounted (): Promise<any> {
      this.billId = `${this.$route.query.orderId}`
      await this.fetchBills()
      this.status = 'กำลังเตรียมการปรินท์'
      this.printer = new Printer()
      setTimeout(async () => {
        await this.openCashBox()
        this.localPrint(true)
      }, 1000)
    }

    async openCashBox (): Promise<boolean> {
      const connected = await this.printer.connect()
      if (connected) {
        this.printer.openCashBox()
      }
      return true
    }

    async localPrint (isTwice = false): Promise<void> {
      // this.printLoading = true
      try {
          const connected = await this.printer.connect()
          if (connected) {
              this.status = 'กำลังเชื่อมต่อกับเครื่องปรินท์'
              const el: HTMLElement | any = this.$refs.receiptTemplate
              const elementToConvert = await html2canvas(el.$el, {
                scale: 1
              })
              if (elementToConvert) {
                this.base64Url = elementToConvert.toDataURL('image/png')
                this.status = 'กำลังเตรียมข้อมูลเพื่อปรินท์'
              } else {
                this.status = 'การเตรียมข้อมูลเพื่อปรินท์ผิดพลาด'
              }
              this.printer.initPrinter()
              if (this.base64Url) {
                  this.status = 'กำลังทำการปรินท์'
                  if (isTwice) {
                    await this.printer.printSingleBitmap(this.base64Url, 53)
                    await this.printer.printAndFeedPaper(100)
                    await this.printer.partialCut()
                    await this.printer.printSingleBitmap(this.base64Url, 53)
                    await this.printer.printAndFeedPaper(100)
                    await this.printer.partialCut()
                  } else {
                    await this.printer.printSingleBitmap(this.base64Url, 53)
                    await this.printer.printAndFeedPaper(100)
                    await this.printer.partialCut()
                  }
                  setTimeout(() => {
                    this.status = 'ปรินท์เสร็จสิ้น'
                  }, 5000)
              } else {
                this.status = 'การเตรียมข้อมูลเพื่อปรินท์ผิดพลาด'
              }
          } else {
              this.status = 'ไม่สามารถเชื่อมต่อกับเครื่องปรินท์ได้'
          }
      } catch (error: any) {
          this.status = 'เกิดข้อผิดพลาดกรุณารีเฟรชหรือกดพิมพ์ใบเสร็จอีกครั้ง'
      }
      // this.printLoading = false
    }

    async fetchBills (): Promise<boolean> {
      try {
        this.loading = true
          this.bill = null
          const upperCaseKeyword = this.billId.toUpperCase()
          const { data } = await orderProvider.fetchBillingByOrderId(upperCaseKeyword)
          if (data) {
              this.bill = data
          } else {
            this.showErrorAlert()
          }
        } catch (error) {
            this.showErrorAlert()
        } finally {
            this.loading = false
        }
        return true
    }

    showErrorAlert (): void {
      this.$buefy.dialog.alert({
          title: 'ไม่พบใบเสร็จที่ค้นหา',
          message: `ไม่พบใบเสร็จเลขที่ <b>"${this.billId}"</b> กรุณาตรวจสอบเลขที่ใบเสร็จอีกครั้ง`,
          confirmText: 'ปิด',
          type: 'is-danger',
          hasIcon: true
      })
    }

    closedOrder (): void {
      if (this.isExchangeOrder) {
        this.exchangeClearCart()
        this.$router.push({ name: 'Home' })
      } else {
        this.clearCart()
        this.$router.push({ name: 'DesktopCart' })
      }
    }

    async manualCut (): Promise<void> {
      const printer = new Printer()
      try {
          const connected = await printer.connect()
          if (connected) {
            await printer.printAndFeedPaper(100)
            await printer.partialCut()
            this.status = ''
          }
      } catch (error: any) {
          this.status = 'เกิดข้อผิดพลาดกรุณารีเฟรชหรือกดพิมพ์ใบเสร็จอีกครั้ง'
      }
    }
}
